import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/images/common-icon/download-file-icon.svg';
import _imports_1 from '@/assets/images/common-icon/download-icon.svg';
const _withScopeId = n => (_pushScopeId("data-v-723ebe1f"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "list"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1));
const _hoisted_3 = {
  class: "list-item-name"
};
const _hoisted_4 = ["onClick"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.list, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: "list-item",
      key: index
    }, [_hoisted_2, _createElementVNode("div", _hoisted_3, _toDisplayString(item.name), 1), _createElementVNode("img", {
      class: "list-item-download",
      onClick: $event => $setup.downloadFile(item),
      src: _imports_1,
      alt: ""
    }, null, 8, _hoisted_4)]);
  }), 128))]);
}